import * as React from "react";
// input 增强组件 | 高阶组件

// 限制输入过长的文字 当前限制为30字符
// input 增强组件 | 高阶组件

export default function inputEnhance(WrappedComponent) {
  return class extends React.Component<any, any> {
    render() {
      // Wraps the input component in a container, without mutating it. Good!
      return (
        <WrappedComponent
          {...this.props}
          maxLength={this.props.maxLength || 30}
        />
      );
    }
  };
}
